export const PDP_RECOMMENDED_PRODUCTS_ANALYTICS_CATEGORY =
  'PdpRecommendedProducts';

export const PDP_RECOMMENDED_PRODUCTS_ITEM_LIST_ID = 'pdp_recommended_products';
export const PDP_RECOMMENDED_PRODUCTS_ITEM_LIST_NAME =
  'PDP Recommended Products';

export interface PdpRecommendedProductsCardPayload {
  category: string;
  product_sku: string | null;
  selected_sku: string | null;
  position: number;
  has_selection: boolean;
}

export interface PdpRecommendedProductsDisplayAttributePayload {
  category: string;
  display_attribute: string;
  display_attribute_option: string | null;
  display_attribute_label: string | null;
  position: number;
  has_selection: boolean;
}

export interface PdpRecommendedProductsAttribution {
  pdp_category: string;
  pdp_result_position: number;
  pdp_main_product_sku: string;
  item_list_id: typeof PDP_RECOMMENDED_PRODUCTS_ITEM_LIST_ID;
  item_list_name: typeof PDP_RECOMMENDED_PRODUCTS_ITEM_LIST_NAME;
  selected_via_pdp_dropdown: true;
}

export interface PdpRecommendedProductsAttributionOptions {
  pdp_category: string;
  pdp_result_position: number;
  pdp_main_product_sku: string;
}
